<template>
  <div>
    
    <div id="mainapp"> 
      <div class="row header">
      <a class="image_logo" href="/">
        <div class="col-6">
          <img style="height: 40px;" src="/images/logoasc.png" title="На главную">
        </div>
      </a>
    </div>
      
      <div class="appcontainer">
        <div class="content">
            <router-view></router-view>
          </div>
    
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
     
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue